import { Button } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MegaphoneOMIcon } from '@omnea-app/icons'
import { FeatureTourDialog } from '@omnea-app/omui/FeatureTourDialog'
import { auctionsWhatsNewAnalytics } from './auctionsWhatsNewAnalytics'

const STEPS = [
  { key: 'reverse-auctions', image: '/app/assets/auctions-comms/step-1-reverse-live-auctions.png' },
  { key: 'lots', image: '/app/assets/auctions-comms/step-2-auctions-into-lots.png' },
  { key: 'award', image: '/app/assets/auctions-comms/step-3-single-or-multiple-suppliers.png' },
  { key: 'rfx-auction', image: '/app/assets/auctions-comms/step-4-extend-sourcing-event.png' },
] as const

export const AuctionsWhatsNew = () => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'rfx-section.whats-new' })
  const { t: tCommon } = useTranslation('common')
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        startIcon={<MegaphoneOMIcon />}
        onClick={() => {
          auctionsWhatsNewAnalytics.clicked()
          setOpen(true)
        }}
      >
        {t('button')}
      </Button>
      <FeatureTourDialog
        open={open}
        onClose={() => setOpen(false)}
        steps={STEPS.map((step) => ({
          ...step,
          title: t(`steps.${step.key}.title`),
          body: t(`steps.${step.key}.body`),
        }))}
        labels={{ close: tCommon('dialog.close'), skip: t('skip'), next: t('next'), finish: tCommon('dialog.close') }}
        onNext={auctionsWhatsNewAnalytics.nextClicked}
      />
    </>
  )
}
